/**
 * Localization messages for RoleDetails component
 */
import sharedMessages from '../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../utils/localization';

const componentMessages = {
  // Component-specific messages
  'Role Description': 'roleRecs.roleDetails.roleDescriptionTitle',
  'Review the description and included access before converting to a Role.':
    'roleRecs.roleDetails.subtitle',
  'A role already exists in the system with this name':
    'roleRecs.roleDetails.error.roleAlreadyExists',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type RoleDetailsMessage = keyof typeof invertedMessages;

export default invertedMessages;
